import { motion } from "framer-motion";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

export const Team = ({ t }) => (
  <section id="team" className="border-t border-white/10 bg-[#040918]" data-testid="team-section">
    <div className="mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-40">
      <motion.p {...reveal()} className="mb-6 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]" data-testid="team-kicker">
        / {t.kicker}
      </motion.p>
      <motion.h2 {...reveal()} className="font-display text-3xl font-semibold tracking-tight md:text-5xl" data-testid="team-title">
        {t.title}
      </motion.h2>

      <div className="mt-16 grid gap-4 md:grid-cols-2">
        {t.members.map((m, i) => (
          <motion.div
            key={m.name}
            {...reveal(i * 0.1)}
            className="group clipped-frame relative bg-[#081226] p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#00e5ff]/30 md:p-12"
            data-testid={`team-member-${i}`}
          >
            <div className="flex items-center gap-5">
              <img
                src={m.img}
                alt={m.name}
                className="h-20 w-20 rounded-full border border-[#00e5ff]/30 object-cover object-top"
                data-testid={`team-photo-${i}`}
              />
              <div>
                <h3 className="font-display text-xl font-semibold text-slate-50 md:text-2xl">{m.name}</h3>
                <p className="mt-2 font-mono-spec text-[11px] uppercase tracking-[0.25em] text-[#00e5ff]">{m.role}</p>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400">{m.bio}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
